import React from 'react';

import { Trans } from '@lyearn/i18n';
import { PlugOutline } from '@lyearn/icons';
import { HeaderBanner, HeaderBannerTypes } from '@lyearn/molecules';
import { ResourceStatusEnum } from '@/types/schema';

import { WorkspaceHeadlineProps } from './types';

const items = {
  [ResourceStatusEnum.Active]: {
    i18nKey: 'Common:Header.WorkspaceHeadline.Received',
    appearance: 'purple',
  },
  [ResourceStatusEnum.Revoked]: {
    i18nKey: 'Common:Header.WorkspaceHeadline.Received',
    appearance: 'archived',
  },
};

const WorkspaceHeadline: React.FC<WorkspaceHeadlineProps> = (props) => {
  const { className, content, workspaceName, status } = props;
  const item = items[status];
  const title = <Trans i18nKey={item.i18nKey} values={{ workspaceName, content }} />;

  return (
    <HeaderBanner
      StartIcon={PlugOutline}
      appearance={item.appearance as HeaderBannerTypes}
      className={className}
      title={title}
    />
  );
};

export default WorkspaceHeadline;
